<template>
  <layout>
    <div class="login-form-container">
      <div class="login-form-inner">
        <div class="logo">
          <img src="assets/logo.png" alt="" style="margin-bottom: 30px" />
        </div>
        <h1>
          Welcome to <span class="nowrap">Navigator <sup>360</sup></span>
        </h1>
        <hr />
        <form @submit.prevent="submit" id="login-form" style="margin-top: 30px">
          <p style="margin-bottom: 30px">
            Please choose a password to continue
          </p>
          <b-field label="Your Name">
            <b-input
              :value="
                $page.props.auth.user.first_name +
                ' ' +
                $page.props.auth.user.last_name
              "
              disabled="true"
            ></b-input>
          </b-field>
          <b-field label="Your Email">
            <b-input
              :value="$page.props.auth.user.email"
              disabled="true"
            ></b-input>
          </b-field>
          <b-field label="Choose a new password">
            <b-input
              v-model="form.password"
              type="password"
              password-reveal
            ></b-input>
          </b-field>
          <b-field label="Confirm new password">
            <b-input
              v-model="form.password_confirmation"
              type="password"
              password-reveal
            ></b-input>
          </b-field>
          <p v-if="errors?.password" style="color: red">
            {{ errors?.password }}
          </p>
          <b-button
            class="is-primary"
            :loading="form.isSending"
            native-type="submit"
          >
            Sign In
          </b-button>
        </form>
      </div>
    </div>
  </layout>
</template>

<script>
import layout from '../Layout';

export default {
  components: {
    layout,
  },
  props: {
    errors: Object,
  },
  data() {
    return {
      form: {
        password: '',
        password_confirmation: '',
        isSending: false,
      },
    };
  },
  methods: {
    submit() {
      const data = {
        password: this.form.password,
        password_confirmation: this.form.password_confirmation,
      };
      this.$inertia.post(this.route('onboarding.setPasswordPost'), data, {
        onStart: () => (this.form.isSending = true),
        onFinish: () => (this.form.isSending = false),
      });
    },
  },
};
</script>
